import React from "react";
import { Button } from "@mui/material";

import "./CharacterAvatar.scss";

import { Block } from "@randajan/jet-react/dom/block";
import { usePagePop } from "../../../PagePops/PagePops";
import { Img } from "../../../../elements/Img/Img";


export const CharacterAvatar = (props)=>{
    const { profile, showMe } = props;
    const { avatar } = (profile || {});

    const pop = usePagePop("avatarForm");

    return (
        <Block className="CharacterAvatar wall -form">
            <div className = "preview">
                <Img src={avatar || "/store/img/userAvatarDefault.png"}/>
            </div>
            {showMe && <section className="controls">{pop?.button}</section>}
        </Block>
    );
};
